import React, { FC } from 'react';
import classnames from 'classnames';
import { SkeletonProps } from './props';
import './styles.scss';

export const Skeleton: FC<SkeletonProps> = ({ wrapperClassName }) => {
  return (
    <div className={classnames('ta-carousel-card-skeleton', wrapperClassName)}>
      <div className="ta-carousel-card-skeleton__left-section-wrapper pulse-fade">
        <div className="ta-carousel-card-skeleton__left-section">
          <div className="ta-carousel-card-skeleton__avatar" />

          <div className="ta-carousel-card-skeleton__company-position" />
          <div className="ta-carousel-card-skeleton__user-position" />
          <div className="ta-carousel-card-skeleton__links" />

          <div className="ta-carousel-card-skeleton__some-message" />
          <div className="ta-carousel-card-skeleton__some-message" />
          <div className="ta-carousel-card-skeleton__some-message" />
          <div className="ta-carousel-card-skeleton__some-message" />
          <div className="ta-carousel-card-skeleton__some-message ta-carousel-card-skeleton__some-message--small" />

          <div className="ta-carousel-card-skeleton__skills-title" />
          <div className="ta-carousel-card-skeleton__skills">
            <div className="ta-carousel-card-skeleton__skill" />
            <div className="ta-carousel-card-skeleton__skill ta-carousel-card-skeleton__skill--small" />
            <div className="ta-carousel-card-skeleton__skill" />
            <div className="ta-carousel-card-skeleton__skill" />
          </div>
        </div>
      </div>

      <div className="ta-carousel-card-skeleton__right-section-wrapper pulse-fade">
        <div className="ta-carousel-card-skeleton__right-section">
          <div className="ta-carousel-card-skeleton__right-section-title" />

          <div className="ta-carousel-card-skeleton__some-message" />
          <div className="ta-carousel-card-skeleton__some-message ta-carousel-card-skeleton__some-message--small" />

          <div className="ta-carousel-card-skeleton__user-additional-info">
            <div className="ta-carousel-card-skeleton__user-additional-info-item">
              <div className="ta-carousel-card-skeleton__user-additional-info-item-label" />
              <div className="ta-carousel-card-skeleton__user-additional-info-item-value" />
            </div>

            <div className="ta-carousel-card-skeleton__user-additional-info-item">
              <div className="ta-carousel-card-skeleton__user-additional-info-item-label" />
              <div className="ta-carousel-card-skeleton__user-additional-info-item-value" />
            </div>

            <div className="ta-carousel-card-skeleton__user-additional-info-item">
              <div className="ta-carousel-card-skeleton__user-additional-info-item-label" />
              <div className="ta-carousel-card-skeleton__user-additional-info-item-value ta-carousel-card-skeleton__user-additional-info-item-value--small" />
            </div>
          </div>

          <div className="ta-carousel-card-skeleton__history-title" />

          <div className="ta-carousel-card-skeleton__right-section-row">
            <div className="ta-carousel-card-skeleton__logo" />

            <div className="ta-carousel-card-skeleton__right-section-row-inner">
              <div className="ta-carousel-card-skeleton__right-section-line" />
              <div className="ta-carousel-card-skeleton__right-section-line ta-carousel-card-skeleton__right-section-line--small" />
            </div>
          </div>

          <div className="ta-carousel-card-skeleton__right-section-row">
            <div className="ta-carousel-card-skeleton__logo" />

            <div className="ta-carousel-card-skeleton__right-section-row-inner">
              <div className="ta-carousel-card-skeleton__right-section-line" />
              <div className="ta-carousel-card-skeleton__right-section-line ta-carousel-card-skeleton__right-section-line--small" />
            </div>
          </div>

          <div className="ta-carousel-card-skeleton__right-section-row">
            <div className="ta-carousel-card-skeleton__logo" />

            <div className="ta-carousel-card-skeleton__right-section-row-inner">
              <div className="ta-carousel-card-skeleton__right-section-line" />
              <div className="ta-carousel-card-skeleton__right-section-line ta-carousel-card-skeleton__right-section-line--small" />
            </div>
          </div>

          <div className="ta-carousel-card-skeleton__right-section-row">
            <div className="ta-carousel-card-skeleton__logo" />

            <div className="ta-carousel-card-skeleton__right-section-row-inner">
              <div className="ta-carousel-card-skeleton__right-section-line ta-carousel-card-skeleton__right-section-line--medium" />
              <div className="ta-carousel-card-skeleton__right-section-line ta-carousel-card-skeleton__right-section-line--small" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
